import { createApp } from 'vue';
import SubscriptionPageVue from './subscription-page.vue';

export class SubscriptionPage {
    constructor(el, options) {
        this.props = options;
        this.init(el);
    }

    init(el) {
        const app = createApp(SubscriptionPageVue, this.props);
        app.mount(el);
    }
}